import { VuexModule, Module, Mutation, Action } from "vuex-class-modules";

export interface IToastOptions {
  message: string;
  shake?: boolean;
  ms?: number;
}

@Module
export class ToastModule extends VuexModule {
  private _open: number = 0;
  private _options: IToastOptions = {
    message: '',
    shake: false,
    ms: 3000
  };

  get options() : IToastOptions  {
    return this._options;
  }

  get opens() : number {
    return this._open;
  }

  @Mutation
  private setOptions(options: IToastOptions) : void {
    this._options = {
      message: options.message,
      ms: options.ms ?? 3000,
      shake: options.shake ?? false
    };
  }

  @Mutation
  private open() : void {
    this._open++;
  }

  @Action
  sendMessage(options: IToastOptions) : void {
    this.setOptions(options);
    this.open();
  }
}